import { render, staticRenderFns } from "./ClientAddLocation.vue?vue&type=template&id=198048ab&"
import script from "./ClientAddLocation.vue?vue&type=script&lang=js&"
export * from "./ClientAddLocation.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddLocation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports